import { render, staticRenderFns } from "./CmgFacPill.vue?vue&type=template&id=317be8d7&scoped=true&lang=pug&"
import script from "./cmg-fac-pill.ts?vue&type=script&lang=ts&"
export * from "./cmg-fac-pill.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFacPill.vue?vue&type=style&index=0&id=317be8d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317be8d7",
  null
  
)

export default component.exports